(function () {
  const gate = document.getElementById("age-gate");
  const confirm = document.getElementById("age-confirm");
  const deny = document.getElementById("age-deny");

  if (!gate) return;

  const isBot = /Googlebot|bingbot|Slurp|DuckDuckBot|YandexBot/i.test(
    navigator.userAgent
  );

  if (isBot) return;

  if (!localStorage.getItem("age_verified")) {
    gate.classList.add("show");
    document.body.style.overflow = "hidden";
  }

  confirm.addEventListener("click", () => {
    localStorage.setItem("age_verified", "true");
    gate.classList.remove("show");
    document.body.style.overflow = "";
  });

  deny.addEventListener("click", () => {
    window.location.href = "https://www.google.com";
  });
})();